document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('atom-saas-avatar-modal');

  if (!modal) {
    return;
  }

  const openButton = document.getElementById('atom-saas-avatar-open');
  const changeButton = document.getElementById('atom-saas-avatar-change');
  const closeButton = document.getElementById('atom-saas-avatar-close');
  const cancelButton = document.getElementById('atom-saas-avatar-cancel');
  const backdrop = modal.querySelector('.atom-saas-avatar-modal-backdrop');

  const chooseButton = document.getElementById('atom-saas-avatar-choose');
  const cameraButton = document.getElementById('atom-saas-avatar-camera-button');
 const cameraPreview = document.getElementById('atom-saas-avatar-camera-preview');
 const cameraVideo = document.getElementById('atom-saas-avatar-camera-video');
 const cameraCapture = document.getElementById('atom-saas-avatar-camera-capture');

  const fileInput = document.getElementById('atom-saas-avatar-file');
  const cameraInput = document.getElementById('atom-saas-avatar-camera-file');

  const canvas = document.getElementById('atom-saas-avatar-canvas');
  const ctx = canvas.getContext('2d');

  const zoomRange = document.getElementById('atom-saas-avatar-zoom-range');
  const zoomOut = document.getElementById('atom-saas-avatar-zoom-out');
  const zoomIn = document.getElementById('atom-saas-avatar-zoom-in');

  const saveButton = document.getElementById('atom-saas-avatar-save');
  const csrfInput = document.getElementById('atom-saas-avatar-csrf');

  const message = document.getElementById('atom-saas-avatar-message');

  const image = new Image();

  let cameraStream = null;

 let imageLoaded = false;
  let baseScale = 1;
  let zoom = 1;
  let offsetX = 0;
  let offsetY = 0;

  let dragging = false;
  let pointerStartX = 0;
  let pointerStartY = 0;
  let offsetStartX = 0;
  let offsetStartY = 0;

  const cropMargin = 0.07;

  function setMessage(text = '') {
    message.textContent = text;
  }

  function stopCamera() {
 if (cameraStream) {
 cameraStream.getTracks().forEach((track) => track.stop());
 cameraStream = null;
 }

 if (cameraVideo) {
 cameraVideo.srcObject = null;
 }

 if (cameraPreview) {
 cameraPreview.hidden = true;
 }
 }

 async function startCamera() {
 if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
 cameraInput.click();
 return;
 }

 try {
 stopCamera();
 setMessage("Opening camera...");
 cameraStream = await navigator.mediaDevices.getUserMedia({
 video: { facingMode: "user" },
 audio: false
 });
 cameraVideo.srcObject = cameraStream;
 cameraPreview.hidden = false;
 await cameraVideo.play();
 setMessage("");
 } catch (error) {
 stopCamera();
 setMessage("Unable to access the camera. Check the browser camera permission.");
 }
 }

 function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('atom-saas-avatar-modal-open');
    setMessage('');
  }

  function closeModal() {
 stopCamera();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('atom-saas-avatar-modal-open');
    dragging = false;
  }

  function cropBounds() {
    const margin = canvas.width * cropMargin;

    return {
      left: margin,
      top: margin,
      right: canvas.width - margin,
      bottom: canvas.height - margin,
      size: canvas.width - (margin * 2)
    };
  }

  function clampOffsets() {
    if (!imageLoaded) {
      return;
    }

    const crop = cropBounds();
    const scale = baseScale * zoom;

    const width = image.naturalWidth * scale;
    const height = image.naturalHeight * scale;

    const minX = crop.right - width;
    const maxX = crop.left;

    const minY = crop.bottom - height;
    const maxY = crop.top;

    offsetX = Math.min(maxX, Math.max(minX, offsetX));
    offsetY = Math.min(maxY, Math.max(minY, offsetY));
  }

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (!imageLoaded) {
      return;
    }

    clampOffsets();

    const scale = baseScale * zoom;
    const width = image.naturalWidth * scale;
    const height = image.naturalHeight * scale;

    ctx.drawImage(
      image,
      offsetX,
      offsetY,
      width,
      height
    );
  }

  function centerImage() {
    const crop = cropBounds();

    const scaleX = crop.size / image.naturalWidth;
    const scaleY = crop.size / image.naturalHeight;

    baseScale = Math.max(scaleX, scaleY);
    zoom = 1;

    zoomRange.value = '1';

    const width = image.naturalWidth * baseScale;
    const height = image.naturalHeight * baseScale;

    offsetX = crop.left + ((crop.size - width) / 2);
    offsetY = crop.top + ((crop.size - height) / 2);

    draw();
  }

  function loadFile(file) {
    if (!file) {
      return;
    }

    if (!file.type.startsWith('image/')) {
      setMessage('Please choose an image file.');
      return;
    }

    if (file.size > 20 * 1024 * 1024) {
      setMessage('The image must be smaller than 20 MB.');
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      image.onload = () => {
        imageLoaded = true;
        centerImage();
        saveButton.disabled = false;
        setMessage('');
      };

      image.onerror = () => {
        imageLoaded = false;
        saveButton.disabled = true;
        setMessage('Unable to load this image.');
      };

      image.src = event.target.result;
    };

    reader.readAsDataURL(file);
  }

  function changeZoom(newZoom) {
    if (!imageLoaded) {
      return;
    }

    newZoom = Math.min(3, Math.max(1, newZoom));

    const crop = cropBounds();
    const centerX = crop.left + (crop.size / 2);
    const centerY = crop.top + (crop.size / 2);

    const oldScale = baseScale * zoom;

    const imagePointX = (centerX - offsetX) / oldScale;
    const imagePointY = (centerY - offsetY) / oldScale;

    zoom = newZoom;
    zoomRange.value = zoom.toFixed(2);

    const newScale = baseScale * zoom;

    offsetX = centerX - (imagePointX * newScale);
    offsetY = centerY - (imagePointY * newScale);

    draw();
  }

  function pointerPosition(event) {
    const rect = canvas.getBoundingClientRect();

    return {
      x: (event.clientX - rect.left) * (canvas.width / rect.width),
      y: (event.clientY - rect.top) * (canvas.height / rect.height)
    };
  }

  function startDrag(event) {
    if (!imageLoaded) {
      return;
    }

    dragging = true;

    const point = pointerPosition(event);

    pointerStartX = point.x;
    pointerStartY = point.y;

    offsetStartX = offsetX;
    offsetStartY = offsetY;

    canvas.setPointerCapture(event.pointerId);
    event.preventDefault();
  }

  function moveDrag(event) {
    if (!dragging || !imageLoaded) {
      return;
    }

    const point = pointerPosition(event);

    offsetX = offsetStartX + (point.x - pointerStartX);
    offsetY = offsetStartY + (point.y - pointerStartY);

    draw();
    event.preventDefault();
  }

  function stopDrag(event) {
    if (!dragging) {
      return;
    }

    dragging = false;

    if (canvas.hasPointerCapture(event.pointerId)) {
      canvas.releasePointerCapture(event.pointerId);
    }
  }

  if (openButton) {
    openButton.addEventListener('click', openModal);
  }

  if (changeButton) {
    changeButton.addEventListener('click', openModal);
  }

  closeButton.addEventListener('click', closeModal);
  cancelButton.addEventListener('click', closeModal);
  backdrop.addEventListener('click', closeModal);

  chooseButton.addEventListener('click', () => {
    stopCamera();
 fileInput.click();
  });

  cameraButton.addEventListener('click', () => {
    startCamera();
  });

  cameraCapture.addEventListener('click', () => {
 if (!cameraVideo.videoWidth || !cameraVideo.videoHeight) {
 setMessage("Camera is not ready yet.");
 return;
 }

 const captureCanvas = document.createElement('canvas');
 captureCanvas.width = cameraVideo.videoWidth;
 captureCanvas.height = cameraVideo.videoHeight;
 const captureContext = captureCanvas.getContext('2d');
 captureContext.drawImage(cameraVideo, 0, 0, captureCanvas.width, captureCanvas.height);

 stopCamera();

 captureCanvas.toBlob((blob) => {
 if (!blob) {
 setMessage("Unable to capture the photo.");
 return;
 }
 loadFile(blob);
 }, 'image/jpeg', 0.92);
 });

 fileInput.addEventListener('change', () => {
    loadFile(fileInput.files[0]);
    fileInput.value = '';
  });

  cameraInput.addEventListener('change', () => {
    loadFile(cameraInput.files[0]);
    cameraInput.value = '';
  });

  zoomRange.addEventListener('input', () => {
    changeZoom(parseFloat(zoomRange.value));
  });

  zoomOut.addEventListener('click', () => {
    changeZoom(zoom - 0.1);
  });

  zoomIn.addEventListener('click', () => {
    changeZoom(zoom + 0.1);
  });

  canvas.addEventListener('pointerdown', startDrag);
  canvas.addEventListener('pointermove', moveDrag);
  canvas.addEventListener('pointerup', stopDrag);
  canvas.addEventListener('pointercancel', stopDrag);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

    saveButton.addEventListener('click', () => {
    if (!imageLoaded || !csrfInput || !csrfInput.value) {
      setMessage('Unable to save the photo.');
      return;
    }

    const crop = cropBounds();
    const outputCanvas = document.createElement('canvas');
    outputCanvas.width = 512;
    outputCanvas.height = 512;

    const outputContext = outputCanvas.getContext('2d');

    outputContext.drawImage(
      canvas,
      crop.left,
      crop.top,
      crop.size,
      crop.size,
      0,
      0,
      512,
      512
    );

    saveButton.disabled = true;
    setMessage('Saving photo...');

    outputCanvas.toBlob(async (blob) => {
      if (!blob) {
        saveButton.disabled = false;
        setMessage('Unable to process the photo.');
        return;
      }

      const formData = new FormData();
      formData.append('avatar', blob, 'avatar.webp');
      formData.append('_csrf_token', csrfInput.value);

      try {
        const response = await fetch('/atomSaasAvatar/upload', {
          method: 'POST',
          credentials: 'same-origin',
          body: formData
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          throw new Error(data.error || 'Unable to save the photo.');
        }

        setMessage('Photo saved.');

        window.setTimeout(() => {
          window.location.reload();
        }, 400);
      } catch (error) {
        saveButton.disabled = false;
        setMessage(error.message || 'Unable to save the photo.');
      }
    }, 'image/webp', 0.9);
  });

  draw();
});
